import { SummaryRow } from '../../../Summary/SummaryRow';

import { Q } from '../../../../store/student/types';
import { IRisk } from '../../../../types';
import { partnerVisaStatusSummaryRow } from '../../../pages/history/qPage3/utils';

interface Props {
  showRisks: boolean;
  hasDependents?: string;
  hasPartner?: string;
  hasChildren?: string;
  partnerVisaStatus?: string;
  childrenNum: string;
  riskList?: IRisk['historyRisk']['travellersAndDependants'];
}

function UpcomingVisaAndDependants({
  showRisks,
  hasDependents,
  hasPartner,
  partnerVisaStatus,
  hasChildren,
  childrenNum,
  riskList = [],
}: Props) {
  return (
    <>
      <SummaryRow
        key="hasDependents"
        label="Anyone coming with you"
        fullLabel="Do you have anyone coming with you to the UK?"
        value={hasDependents}
        isRisk={showRisks && riskList.includes(Q.FAMILY_MEMBERS_TRAVELLING)}
      />

      <SummaryRow
        key="spouse"
        label="Partner applying for a UK visa or is already in the UK"
        fullLabel="Do you have a partner that is either applying for a UK visa or has a UK visa?"
        value={hasPartner}
        isRisk={showRisks && riskList.includes(Q.SPOUSE_TRAVELLING)}
      />

      {hasPartner === 'Yes' && (
        <SummaryRow
          key="partner"
          label="Partner is"
          fullLabel="My partner is..."
          value={partnerVisaStatusSummaryRow(partnerVisaStatus)}
          isRisk={showRisks && riskList.includes(Q.PARTNER_VISA_STATUS)}
        />
      )}

      <SummaryRow
        key="children"
        label="Applying for a Student visa with dependant Children"
        fullLabel="Are you applying for your Student visa with dependant children?"
        value={hasChildren}
        isRisk={showRisks && riskList.includes(Q.CHILDREN_TRAVELLING)}
      />

      {hasDependents === 'Yes' && hasChildren === 'Yes' && (
        <SummaryRow
          key="childrenNum"
          label="Num of Children"
          fullLabel="How many children?"
          value={childrenNum}
          isRisk={showRisks && riskList.includes(Q.CHILDREN_TRAVELLING_NUMBER)}
        />
      )}
    </>
  );
}

export default UpcomingVisaAndDependants;
